
export function MissionSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Our Mission
              </h2>
              <p className="text-lg text-gray-400 mb-6 leading-relaxed">
                To democratize cybersecurity by developing AI solutions that give small businesses enterprise-level protection without the complexity or high cost barriers.
              </p>
              <p className="text-lg text-gray-400 mb-8 leading-relaxed">
                Driscop is building AI-powered protection that serves people, not overwhelms them. Our approach is designed to simplify cyber defense into an automated, proactive, and educational experience that will empower SMEs to operate confidently in a digital world.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-400 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">Accessible Protection</h3>
                    <p className="text-gray-400">Developing enterprise-grade security that will be simple and affordable for every UK business</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-400 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">Continuous Education</h3>
                    <p className="text-gray-400">Designing security solutions that will turn every moment into a learning opportunity for your team</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-check-line text-blue-400 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">Local Expertise</h3>
                    <p className="text-gray-400">UK-trained AI that understands regional threat patterns and business needs</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=500&fit=crop&crop=center"
                alt="Driscop team working on cybersecurity solutions"
                className="w-full h-auto rounded-xl shadow-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
